import AOS from "aos";
import "lazysizes";
import { initMomenceEvents, startMomenceScheduleRefresh } from "./momence.js";
import { initMomenceEmbed } from "./momence-embed.js";

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

AOS.init({
  disable: prefersReducedMotion,
  duration: prefersReducedMotion ? 0 : 800,
  once: true,
  offset: 40,
});

window.addEventListener("load", () => {
  AOS.refresh();
});

document.addEventListener("lazybeforeunveil", function (e) {
  var bg = e.target.getAttribute("data-bg");
  if (bg) {
    e.target.style.backgroundImage = "url(" + bg + ")";
  }
});

initMomenceEmbed();
initMomenceEvents();
startMomenceScheduleRefresh();
